import { render, staticRenderFns } from "./T.vue?vue&type=template&id=08a26af1&scoped=true&"
var script = {}
import style0 from "./T.vue?vue&type=style&index=0&id=08a26af1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a26af1",
  null
  
)

export default component.exports